<template>
  <div>
    <div
      v-if="showing"
      class="fixed pt-24 pb-10 inset-0 w-full h-screen flex items-center justify-center bg-semi-75 z-20"
    >
      <div
        class="mx-2 w-full max-w-lg max-h-full bg-white shadow-lg rounded-lg p-5 overflow-auto"
      >
        <div class="w-full text-right sticky top-0 right-0">
          <button
            aria-label="close"
            class="text-xl text-gray-500"
            @click.prevent="close"
          >
            ×
          </button>
        </div>
        <div class="flex flex-wrap">
          <div-title
            class="w-full text-left px-3 pb-3 text-purple-700 text-2xl font-bold"
            :colorP="colorP"
          >
            Edición de ficha
          </div-title>
          <div class="flex flex-col w-full">
            <form
              class="w-full max-w-lg"
              id="levantamientoForm"
              @submit.prevent
            >
              <!-- Formulario de ficha -->
              <div>
                <div class="flex flex-wrap -mx-3 pb-3">
                  <div
                    class="w-full"
                    v-for="(question, index) in questions"
                    :key="'question' + question.id_pregunta"
                    v-show="isQuestionVisible(index)"
                  >
                    <!-- pregunta tipo ABIERTA -->
                    <div v-if="question.tipo === 'ABIERTA'">
                      <div class="w-full px-3 mb-6 md:mb-0">
                        <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                          :for="'question' + index"
                          >{{ question.numero_pregunta }}.-
                          {{ question.texto }}</label
                        >
                        <p
                          v-if="question.nota_para_registrante"
                          class="text-purple-700 text-xs italic font-bold mb-2 text-left"
                        >
                          {{ question.nota_para_registrante }}
                        </p>
                        <template v-if="question.tipo_dato === 'numero'">
                          <input
                            class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                            :id="'question' + index"
                            type="number"
                            :min="question.rango_min"
                            :max="question.rango_max"
                            :name="'question' + index"
                            v-model.number="answers[index].respuesta"
                          />
                        </template>
                        <template v-else-if="question.tipo_dato === 'fecha'">
                          <input
                            class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                            :id="'question' + index"
                            type="date"
                            :name="'question' + index"
                            v-model="answers[index].respuesta"
                          />
                        </template>
                        <template v-else-if="question.tipo_dato === 'hora'">
                          <input
                            class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                            :id="'question' + index"
                            type="time"
                            :name="'question' + index"
                            v-model="answers[index].respuesta"
                          />
                        </template>
                        <template v-else>
                          <textarea
                            class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                            :id="'question' + index"
                            type="text"
                            :name="'question' + index"
                            v-model="answers[index].respuesta"
                          />
                        </template>
                        <p
                          v-if="answers[index].error"
                          class="text-red-500 text-xs italic pb-3"
                        >
                          Ingrese la respuesta.
                        </p>
                        <p
                          v-if="answers[index].error_rango"
                          class="text-red-500 text-xs italic pb-3"
                        >
                          El valor debe estar entre {{ question.rango_min !== null ? question.rango_min : '-∞' }} y {{ question.rango_max !== null ? question.rango_max : '∞' }}.
                        </p>
                      </div>
                      <!--                       <div class="w-full px-3 mb-3">
                        <label class="w-full flex items-center text-gray-900">
                          <input
                            class="mr-2 leading-tight"
                            type="checkbox"
                            v-model="answers[index].sensible"
                          />
                          <span class="text-sm">
                            Contiene información sensible
                          </span>
                        </label>
                      </div> -->
                    </div>
                    <!-- /pregunta tipo ABIERTA -->

                    <!-- pregunta tipo FOTO -->
                    <div v-if="question.tipo === 'FOTO'">
                      <div class="w-full px-3 mb-6 md:mb-0">
                        <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                          :for="'question' + index"
                          >{{ question.numero_pregunta }}.-
                          {{ question.texto }}
                          <span class="text-gray-500 font-normal text-xs ml-1">(Máximo {{ question.max_fotos || 4 }} fotos)</span>
                        </label>
                        <p
                          v-if="question.nota_para_registrante"
                          class="text-purple-700 text-xs italic font-bold mb-2 text-left"
                        >
                          {{ question.nota_para_registrante }}
                        </p>
                        <input
                          class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-2 leading-tight focus:outline-none focus:bg-white"
                          type="file"
                          accept="image/*"
                          multiple
                          :disabled="answers[index].respuesta && Array.isArray(answers[index].respuesta) && answers[index].respuesta.length >= (question.max_fotos || 4)"
                          @change="onPhotoChange($event, index)"
                        />
                        <!-- Preview grid -->
                        <div v-if="answers[index].respuesta && Array.isArray(answers[index].respuesta) && answers[index].respuesta.length > 0" class="flex flex-wrap gap-3 mt-2">
                          <div v-for="(photo, pIdx) in answers[index].respuesta" :key="'p_' + pIdx" class="relative">
                            <img :src="photo" class="w-24 h-24 object-cover rounded border border-gray-300 shadow-sm" />
                            <button
                              type="button"
                              class="absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs shadow hover:bg-red-600 focus:outline-none"
                              @click="removePhoto(index, pIdx)"
                              title="Eliminar foto"
                            >×</button>
                          </div>
                        </div>
                        <div v-else-if="answers[index].respuesta && typeof answers[index].respuesta === 'string'" class="relative inline-block mt-2">
                          <img :src="answers[index].respuesta" class="w-28 h-28 object-cover rounded border border-gray-300 shadow-sm" />
                          <button
                            type="button"
                            class="absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs shadow hover:bg-red-600 focus:outline-none"
                            @click="removePhoto(index, 0)"
                            title="Eliminar foto"
                          >×</button>
                        </div>
                        <p v-if="answers[index].error" class="text-red-500 text-xs italic mt-1">
                          Debe adjuntar al menos una fotografía.
                        </p>
                      </div>
                    </div>
                    <!-- /pregunta tipo FOTO -->

                    <!-- pregunta tipo MULTISELECCION -->
                    <div v-if="question.tipo === 'MULTISELECCION'">
                      <div class="w-full px-3 mb-6 md:mb-0">
                        <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                          :for="'question' + index"
                          >{{ question.numero_pregunta }}.-
                          {{ question.texto }}</label
                        >
                        <p
                          v-if="question.nota_para_registrante"
                          class="text-purple-700 text-xs italic font-bold mb-2 text-left"
                        >
                          {{ question.nota_para_registrante }}
                        </p>
                        <template
                          v-for="(option, optIndex) in question.opciones"
                        >
                          <div
                            class="flex items-center text-gray-700 font-bold"
                            :class="
                              optIndex === question.opciones.length - 1 &&
                              !question.otro
                                ? 'mb-3'
                                : ''
                            "
                            :key="'opt' + optIndex"
                          >
                            <input
                              class="mr-2 leading-tight"
                              type="checkbox"
                              v-model="
                                answers[index].respuesta.opciones[option]
                              "
                            />
                            <span class="text-sm">
                              {{ option }}
                            </span>
                          </div>
                        </template>
                        <div
                          v-if="question.otro"
                          class="flex items-center text-gray-700 font-bold mb-3"
                        >
                          <input class="mr-2 leading-tight" type="checkbox" />
                          <span class="text-sm"> Otro </span>
                          <input
                            v-if="!question.tipo_otro || question.tipo_otro === 'texto'"
                            type="text"
                            class="appearance-none bg-gray-200 text-gray-700 border rounded py-2 px-4 ml-2 leading-tight focus:outline-none focus:bg-white"
                            v-model="answers[index].respuesta.otro"
                          />
                          <input
                            v-else-if="question.tipo_otro === 'numero'"
                            type="number"
                            class="appearance-none bg-gray-200 text-gray-700 border rounded py-2 px-4 ml-2 leading-tight focus:outline-none focus:bg-white"
                            v-model.number="answers[index].respuesta.otro"
                          />
                          <input
                            v-else-if="question.tipo_otro === 'fecha'"
                            type="date"
                            class="appearance-none bg-gray-200 text-gray-700 border rounded py-2 px-4 ml-2 leading-tight focus:outline-none focus:bg-white"
                            v-model="answers[index].respuesta.otro"
                          />
                          <input
                            v-else-if="question.tipo_otro === 'hora'"
                            type="time"
                            class="appearance-none bg-gray-200 text-gray-700 border rounded py-2 px-4 ml-2 leading-tight focus:outline-none focus:bg-white"
                            v-model="answers[index].respuesta.otro"
                          />
                        </div>

                        <!-- Subpreguntas de la pregunta multiselección -->
                        <template
                          v-for="(
                            subpregunta, subSIndex
                          ) in question.subpregunta"
                        >
                          <div
                            class="w-full px-3 mb-6 md:mb-0"
                            :key="'subS' + subSIndex"
                          >
                            <label
                              class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                              :for="'subquestion' + subSIndex"
                              >{{ subpregunta.id_pregunta }}.-
                              {{ subpregunta.texto }}</label
                            >
                            <!-- Subpregunta tipo multiselección->abierta -->
                            <template v-if="subpregunta.tipo === 'ABIERTA'">
                              <textarea
                                class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                :id="'subquestion' + subSIndex"
                                type="text"
                                :name="'subquestion' + subSIndex"
                                v-model="
                                  answers[index].respuesta.subpregunta[
                                    subSIndex
                                  ].respuesta
                                "
                              />
                              <p
                                v-if="
                                  answers[index].respuesta.subpregunta[
                                    subSIndex
                                  ].error
                                "
                                class="text-red-500 text-xs italic pb-3"
                              >
                                Ingrese la respuesta.
                              </p>
                              <!--                             <div class="w-full px-3 mb-3">
                              <label
                                class="w-full flex items-center text-gray-900"
                              >
                                <input
                                  class="mr-2 leading-tight"
                                  type="checkbox"
                                  v-model="
                                    answers[index].respuesta.subpregunta[
                                      subSIndex
                                    ].sensible
                                  "
                                />
                                <span class="text-sm">
                                  Contiene información sensible
                                </span>
                              </label>
                            </div> -->
                            </template>
                            <!-- /Subpregunta tipo multiselección->abierta -->

                            <!-- /Subpregunta tipo multiselección->selección -->
                            <template v-if="subpregunta.tipo === 'SELECCION'">
                              <div class="relative">
                                <select
                                  v-model="
                                    answers[index].respuesta.subpregunta[
                                      subSIndex
                                    ].respuesta.selected_answer
                                  "
                                  :name="'subquestion' + subSIndex"
                                  class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 mb-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                >
                                  <option disabled selected>
                                    Seleccione una
                                  </option>
                                  <template
                                    v-for="(
                                      option, subOIndex
                                    ) in subpregunta.opciones"
                                  >
                                    <option
                                      :key="'subO' + subOIndex"
                                      :value="option"
                                    >
                                      {{ option }}
                                    </option>
                                  </template>
                                  <option
                                    v-if="subpregunta.otro == true"
                                    value="Otro"
                                  >
                                    Otro
                                  </option>
                                </select>

                                <div
                                  class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                                >
                                  <svg
                                    class="fill-current h-4 w-4"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 20 20"
                                  >
                                    <path
                                      d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                                    />
                                  </svg>
                                </div>
                              </div>

                              <div
                                v-if="
                                  answers[index].respuesta.subpregunta[
                                    subSIndex
                                  ].respuesta.selected_answer === 'Otro'
                                "
                                class="flex items-center text-gray-700 font-bold mb-3"
                              >
                                <span class="text-sm"> Otro </span>
                                <input
                                  type="text"
                                  class="appearance-none bg-gray-200 text-gray-700 border rounded py-2 px-4 ml-2 leading-tight focus:outline-none focus:bg-white"
                                  v-model="
                                    answers[index].respuesta.subpregunta[
                                      subSIndex
                                    ].respuesta.otro
                                  "
                                />
                              </div>

                              <p
                                v-if="
                                  answers[index].respuesta.subpregunta[
                                    subSIndex
                                  ].error
                                "
                                class="text-red-500 text-xs italic pb-3"
                              >
                                Seleccione la respuesta.
                              </p>
                            </template>
                            <!-- /Subpregunta tipo multiselección->selección -->

                            <!-- Subpregunta tipo multiselección->campos -->
                            <template v-if="subpregunta.tipo === 'CAMPOS'">
                              <template
                                v-for="(
                                  campo, subFieldIndex
                                ) in subpregunta.campos"
                              >
                                <template v-if="campo.tipo === 'texto'">
                                  <div :key="'subf' + subFieldIndex">
                                    <label
                                      class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                                      :for="'subquestionField' + subFieldIndex"
                                      >{{ campo.texto }}</label
                                    >
                                    <input
                                      class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                      :id="'subquestionField' + subFieldIndex"
                                      type="text"
                                      :name="'subquestionField' + subFieldIndex"
                                      v-model="
                                        answers[index].respuesta.subpregunta[
                                          subSIndex
                                        ].respuesta[campo.texto]
                                      "
                                    />
                                  </div>
                                </template>
                              </template>
                              <p
                                v-if="
                                  answers[index].respuesta.subpregunta[
                                    subSIndex
                                  ].error
                                "
                                class="text-red-500 text-xs italic pb-3"
                              >
                                Ingrese la respuesta.
                              </p>
                              <!--                             <div class="w-full px-3 mb-3">
                              <label
                                class="w-full flex items-center text-gray-900"
                              >
                                <input
                                  class="mr-2 leading-tight"
                                  type="checkbox"
                                  v-model="
                                    answers[index].respuesta.subpregunta[
                                      subSIndex
                                    ].sensible
                                  "
                                />
                                <span class="text-sm">
                                  Contiene información sensible
                                </span>
                              </label>
                            </div> -->
                            </template>
                            <!-- /Subpregunta tipo multiselección->campos -->
                          </div>
                        </template>
                        <!-- /Subpreguntas de la pregunta multiselección -->
                      </div>
                    </div>
                    <!-- /pregunta tipo MULTISELECCION -->

                    <!-- pregunta tipo SELECCION_CONDICIONAL -->
                    <div v-if="question.tipo === 'SELECCION_CONDICIONAL'">
                      <div class="w-full px-3 mb-6 md:mb-0">
                        <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                          :for="'question' + index"
                          >{{ question.numero_pregunta }}.-
                          {{ question.texto }}</label
                        >
                        <div class="relative">
                          <select
                            v-model="answers[index].respuesta.selected_answer"
                            :name="'question' + index"
                            class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 mb-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                          >
                            <option disabled selected>Seleccione una</option>
                            <template
                              v-for="(option, scOIndex) in question.opciones"
                            >
                              <option :key="'scO' + scOIndex" :value="option">
                                {{ option }}
                              </option>
                            </template>
                          </select>
                          <div
                            class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                          >
                            <svg
                              class="fill-current h-4 w-4"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 20 20"
                            >
                              <path
                                d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                              />
                            </svg>
                          </div>
                        </div>
                        <p
                          v-if="answers[index].error"
                          class="text-red-500 text-xs italic pb-3"
                        >
                          Seleccione la respuesta.
                        </p>
                      </div>

                      <!-- preguntas condicionadas -->
                      <template
                        v-for="(
                          value, key, keyIndex
                        ) in question.pregunta_condicion"
                      >
                        <template
                          v-if="
                            answers[index].respuesta.selected_answer === key
                          "
                        >
                          <!-- pregunta condicionada tipo abierta -->
                          <div
                            v-if="
                              question.pregunta_condicion[key].tipo ===
                              'ABIERTA'
                            "
                            class="w-full px-3 mb-6 md:mb-0"
                            :key="'condQ' + keyIndex"
                          >
                            <label
                              class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                              :for="'questionCond' + index"
                              >{{ question.pregunta_condicion[key].id }}.-
                              {{
                                question.pregunta_condicion[key].texto
                              }}</label
                            >
                            <textarea
                              class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                              :id="'questionCond' + index"
                              type="text"
                              :name="'questionCond' + index"
                              v-model="
                                answers[index].respuesta.conditional_answer[key]
                                  .respuesta
                              "
                            />
                            <p
                              v-if="
                                answers[index].respuesta.conditional_answer[key]
                                  .error
                              "
                              class="text-red-500 text-xs italic pb-3"
                            >
                              Ingrese la respuesta.
                            </p>
                            <!--                             <div class="w-full px-3 mb-3">
                              <label
                                class="w-full flex items-center text-gray-900"
                              >
                                <input
                                  class="mr-2 leading-tight"
                                  type="checkbox"
                                  v-model="
                                    answers[index].respuesta.conditional_answer[
                                      key
                                    ].sensible
                                  "
                                />
                                <span class="text-sm">
                                  Contiene información sensible
                                </span>
                              </label>
                            </div> -->
                          </div>
                          <!-- /pregunta condicionada tipo abierta -->

                          <!-- pregunta condicionada multiselección -->
                          <div
                            v-if="
                              question.pregunta_condicion[key].tipo ===
                              'MULTISELECCION'
                            "
                            class="w-full px-3 mb-6 md:mb-0"
                            :key="'condQ' + keyIndex"
                          >
                            <label
                              class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                              :for="'questionCond' + index"
                              >{{ question.pregunta_condicion[key].id }}.-
                              {{
                                question.pregunta_condicion[key].texto
                              }}</label
                            >
                            <p
                              v-if="
                                question.pregunta_condicion[key]
                                  .nota_para_registrante
                              "
                              class="text-purple-700 text-xs italic font-bold mb-2 text-left"
                            >
                              {{
                                question.pregunta_condicion[key]
                                  .nota_para_registrante
                              }}
                            </p>
                            <template
                              v-for="(option, scMOIndex) in question
                                .pregunta_condicion[key].opciones"
                            >
                              <div
                                class="flex items-center text-gray-700 font-bold"
                                :class="
                                  scMOIndex ===
                                    question.pregunta_condicion[key].opciones
                                      .length -
                                      1 &&
                                  !question.pregunta_condicion[key].otro
                                    ? 'mb-3'
                                    : ''
                                "
                                :key="'scM' + scMOIndex"
                              >
                                <input
                                  class="mr-2 leading-tight"
                                  type="checkbox"
                                  v-model="
                                    answers[index].respuesta.conditional_answer[
                                      key
                                    ].respuesta.opciones[option]
                                  "
                                />
                                <span class="text-sm">
                                  {{ option }}
                                </span>
                              </div>
                            </template>
                            <div
                              v-if="question.pregunta_condicion[key].otro"
                              class="flex items-center text-gray-700 font-bold mb-3"
                            >
                              <input
                                class="mr-2 leading-tight"
                                type="checkbox"
                              />
                              <span class="text-sm"> Otro </span>
                              <input
                                type="text"
                                class="appearance-none bg-gray-200 text-gray-700 border rounded py-2 px-4 ml-2 leading-tight focus:outline-none focus:bg-white"
                                v-model="
                                  answers[index].respuesta.conditional_answer[
                                    key
                                  ].respuesta.otro
                                "
                              />
                            </div>
                          </div>
                          <!-- /pregunta condicionada multiselección -->

                          <!-- pregunta condicionada tipo selección -->
                          <div
                            v-if="
                              question.pregunta_condicion[key].tipo ===
                              'SELECCION'
                            "
                            :key="'condQ' + keyIndex"
                            class="w-full px-3 mb-6 md:mb-0"
                          >
                            <label
                              class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                              :for="'questionCond' + index"
                              >{{ question.pregunta_condicion[key].id }}.-
                              {{
                                question.pregunta_condicion[key].texto
                              }}</label
                            >
                            <p
                              v-if="
                                question.pregunta_condicion[key]
                                  .nota_para_registrante
                              "
                              class="text-purple-700 text-xs italic font-bold mb-2 text-left"
                            >
                              {{
                                question.pregunta_condicion[key]
                                  .nota_para_registrante
                              }}
                            </p>
                            <div class="relative">
                              <select
                                v-model="
                                  answers[index].respuesta.conditional_answer[
                                    key
                                  ].respuesta
                                "
                                :name="'questionCond' + index"
                                class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 mb-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                              >
                                <option disabled selected>
                                  Seleccione una
                                </option>
                                <template
                                  v-for="(option, condOIndex) in question
                                    .pregunta_condicion[key].opciones"
                                >
                                  <option
                                    :key="'condO' + condOIndex"
                                    :value="option"
                                  >
                                    {{ option }}
                                  </option>
                                </template>
                              </select>
                              <div
                                class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                              >
                                <svg
                                  class="fill-current h-4 w-4"
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 20 20"
                                >
                                  <path
                                    d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                                  />
                                </svg>
                              </div>
                            </div>
                          </div>
                          <!-- /pregunta condicionada tipo selección -->

                          <!-- pregunta condicionada tipo campos -->
                          <div
                            v-if="
                              question.pregunta_condicion[key].tipo === 'CAMPOS'
                            "
                            :key="'condQ' + keyIndex"
                            class="w-full px-3 mb-6 md:mb-0"
                          >
                            <template
                              v-for="(campo, condFieldIndex) in question
                                .pregunta_condicion[key].campos"
                            >
                              <template v-if="campo.tipo === 'texto'">
                                <div :key="'condf' + condFieldIndex">
                                  <label
                                    class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                                    :for="'condField' + condFieldIndex"
                                    >{{ campo.texto }}</label
                                  >
                                  <input
                                    class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                    :id="'condField' + condFieldIndex"
                                    type="text"
                                    :name="'condField' + condFieldIndex"
                                    v-model="
                                      answers[index].respuesta
                                        .conditional_answer[key].respuesta[
                                        campo.texto
                                      ]
                                    "
                                  />
                                </div>
                              </template>
                            </template>
                            <!--                             <div class="w-full px-3 mb-3">
                              <label
                                class="w-full flex items-center text-gray-900"
                              >
                                <input
                                  class="mr-2 leading-tight"
                                  type="checkbox"
                                  v-model="
                                    answers[index].respuesta.conditional_answer[
                                      key
                                    ].sensible
                                  "
                                />
                                <span class="text-sm">
                                  Contiene información sensible
                                </span>
                              </label>
                            </div> -->
                          </div>
                          <!-- /pregunta condicionada tipo campos -->
                        </template>
                        <template
                          v-if="
                            answers[index].respuesta.selected_answer === key
                          "
                        >
                          <template
                            v-for="(subpregunta, subQIndex) in question
                              .pregunta_condicion[key].subpregunta"
                          >
                            <div
                              v-if="subpregunta.tipo === 'SELECCION'"
                              :key="'subCondQ' + subQIndex"
                              class="w-full px-3 mb-6 md:mb-0"
                            >
                              <label
                                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                                :for="'subCondQ' + subQIndex"
                                >{{ subpregunta.id_pregunta }}.-
                                {{ subpregunta.texto }}</label
                              >
                              <p
                                v-if="subpregunta.nota_para_registrante"
                                class="text-purple-700 text-xs italic font-bold mb-2 text-left"
                              >
                                {{ subpregunta.nota_para_registrante }}
                              </p>
                              <div class="relative">
                                <select
                                  v-model="
                                    answers[index].respuesta.conditional_answer[
                                      key
                                    ].subpregunta[subQIndex].respuesta
                                  "
                                  :name="'subCondQ' + subQIndex"
                                  class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 mb-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                >
                                  <option disabled selected>
                                    Seleccione una
                                  </option>
                                  <template
                                    v-for="(
                                      option, subCondOptIndex
                                    ) in subpregunta.opciones"
                                  >
                                    <option
                                      :key="'subCondOpt' + subCondOptIndex"
                                      :value="option"
                                    >
                                      {{ option }}
                                    </option>
                                  </template>
                                </select>
                                <div
                                  class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                                >
                                  <svg
                                    class="fill-current h-4 w-4"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 20 20"
                                  >
                                    <path
                                      d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                                    />
                                  </svg>
                                </div>
                              </div>
                            </div>
                          </template>
                        </template>
                      </template>
                      <!-- /preguntas condicionadas -->
                    </div>
                    <!-- /pregunta tipo SELECCION_CONDICIONAL -->

                    <!-- pregunta tipo OPCION_SEGUIMIENTO -->
                    <div v-if="question.tipo === 'OPCION_SEGUIMIENTO'">
                      <div class="w-full px-3 mb-6 md:mb-0">
                        <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                          :for="'question' + index"
                          >{{ question.numero_pregunta }}.-
                          {{ question.texto }}</label
                        >
                        <p
                          v-if="question.nota_para_registrante"
                          class="text-purple-700 text-xs italic font-bold mb-2 text-left"
                        >
                          {{ question.nota_para_registrante }}
                        </p>
                        <!-- Lista de Conceptos -->
                        <div v-for="(concepto, cIdx) in question.conceptos" :key="'concepto_' + cIdx" class="mb-4">
                          <label class="block text-gray-700 text-sm font-bold mb-2 text-left">{{ concepto }}</label>
                          <div class="flex gap-4 mb-2">
                            <label class="flex items-center gap-2 cursor-pointer font-bold text-sm text-gray-700">
                              <input type="radio"
                                :name="'followup_' + index + '_' + cIdx"
                                :value="question.opcion_si"
                                v-model="answers[index].respuesta[cIdx].selected_answer"
                                class="accent-green-500"
                              />
                              {{ question.opcion_si }}
                            </label>
                            <label class="flex items-center gap-2 cursor-pointer font-bold text-sm text-gray-700">
                              <input type="radio"
                                :name="'followup_' + index + '_' + cIdx"
                                :value="question.opcion_no"
                                v-model="answers[index].respuesta[cIdx].selected_answer"
                                class="accent-red-400"
                              />
                              {{ question.opcion_no }}
                            </label>
                          </div>
                          <!-- Sub-formulario (solo cuando selecciona opción SI) -->
                          <transition name="fade">
                            <div v-if="answers[index].respuesta[cIdx].selected_answer === question.opcion_si"
                              class="mt-2 p-3 bg-green-50 border border-green-200 rounded-lg"
                            >
                              <!-- Sub-tipo: radio -->
                              <div v-if="question.sub_tipo === 'radio'">
                                <div :class="question.sub_disposicion === 'horizontal' ? 'flex flex-wrap gap-4' : 'flex flex-col gap-2'">
                                  <label
                                    v-for="(opt, oi) in question.sub_opciones"
                                    :key="'sr_' + index + '_' + cIdx + '_' + oi"
                                    class="flex items-center gap-2 cursor-pointer text-sm text-gray-700"
                                  >
                                    <input type="radio"
                                      :name="'sub_radio_' + index + '_' + cIdx"
                                      :value="opt"
                                      v-model="answers[index].respuesta[cIdx].sub_respuesta"
                                      class="accent-green-500"
                                    />
                                    {{ opt }}
                                  </label>
                                </div>
                              </div>
                              <!-- Sub-tipo: checkbox -->
                              <div v-if="question.sub_tipo === 'checkbox'">
                                <div :class="question.sub_disposicion === 'horizontal' ? 'flex flex-wrap gap-4' : 'flex flex-col gap-2'">
                                  <label
                                    v-for="(opt, oi) in question.sub_opciones"
                                    :key="'sc_' + index + '_' + cIdx + '_' + oi"
                                    class="flex items-center gap-2 cursor-pointer text-sm text-gray-700"
                                  >
                                    <input type="checkbox"
                                      :value="opt"
                                      v-model="answers[index].respuesta[cIdx].sub_respuesta"
                                      class="accent-green-500"
                                    />
                                    {{ opt }}
                                  </label>
                                </div>
                              </div>
                              <!-- Sub-tipo: input -->
                              <div v-if="question.sub_tipo === 'input'">
                                <label v-if="question.sub_label" class="block text-xs font-bold text-gray-600 mb-1 uppercase tracking-wide">{{ question.sub_label }}</label>
                                <input
                                  class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 leading-tight focus:outline-none focus:bg-white"
                                  :type="question.sub_input_tipo === 'numero' ? 'number' : (question.sub_input_tipo === 'fecha' ? 'date' : (question.sub_input_tipo === 'hora' ? 'time' : 'text'))"
                                  :min="question.sub_input_tipo === 'numero' && question.sub_rango_min !== null ? question.sub_rango_min : undefined"
                                  :max="question.sub_input_tipo === 'numero' && question.sub_rango_max !== null ? question.sub_rango_max : undefined"
                                  v-model="answers[index].respuesta[cIdx].sub_respuesta"
                                />
                              </div>
                            </div>
                          </transition>
                        </div>
                        <p v-if="answers[index].error" class="text-red-500 text-xs italic pb-3">Ingrese la respuesta.</p>
                      </div>
                    </div>
                    <!-- /pregunta tipo OPCION_SEGUIMIENTO -->

                    <!-- pregunta tipo SELECCION -->
                    <div v-if="question.tipo === 'SELECCION'">
                      <div class="w-full px-3 mb-6 md:mb-0">
                        <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                          :for="'question' + index"
                          >{{ question.numero_pregunta }}.-
                          {{ question.texto }}</label
                        >
                        <p
                          v-if="question.nota_para_registrante"
                          class="text-purple-700 text-xs italic font-bold mb-2 text-left"
                        >
                          {{ question.nota_para_registrante }}
                        </p>
                        <div class="relative">
                          <select
                            v-model="answers[index].respuesta.selected_answer"
                            :name="'question' + index"
                            class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 mb-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                          >
                            <option disabled selected>Seleccione una</option>
                            <template
                              v-for="(option, sOIndex) in question.opciones"
                            >
                              <option :key="'sO' + sOIndex" :value="option">
                                {{ option }}
                              </option>
                            </template>
                            <option v-if="question.otro == true" value="Otro">
                              Otro
                            </option>
                          </select>
                          <div
                            class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                          >
                            <svg
                              class="fill-current h-4 w-4"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 20 20"
                            >
                              <path
                                d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                              />
                            </svg>
                          </div>
                        </div>
                        <div
                          v-if="
                            answers[index].respuesta.selected_answer === 'Otro'
                          "
                          class="flex items-center text-gray-700 font-bold mb-3"
                        >
                          <span class="text-sm"> Otro </span>
                          <input
                            type="text"
                            class="appearance-none bg-gray-200 text-gray-700 border rounded py-2 px-4 ml-2 leading-tight focus:outline-none focus:bg-white"
                            v-model="answers[index].respuesta.otro"
                          />
                        </div>
                        <p
                          v-if="answers[index].error"
                          class="text-red-500 text-xs italic pb-3"
                        >
                          Seleccione la respuesta.
                        </p>
                      </div>

                      <!-- subpreguntas de la pregunta de selección -->
                      <template
                        v-for="(subpregunta, subSIndex) in question.subpregunta"
                      >
                        <div
                          class="w-full px-3 mb-6 md:mb-0"
                          :key="'subS' + subSIndex"
                        >
                          <label
                            class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                            :for="'subquestion' + subSIndex"
                            >{{ subpregunta.id_pregunta }}.-
                            {{ subpregunta.texto }}</label
                          >
                          <!-- Subpregunta tipo selección->abierta -->
                          <template v-if="subpregunta.tipo === 'ABIERTA'">
                            <textarea
                              class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                              :id="'subquestion' + subSIndex"
                              type="text"
                              :name="'subquestion' + subSIndex"
                              v-model="
                                answers[index].respuesta.subpregunta[subSIndex]
                                  .respuesta
                              "
                            />
                            <p
                              v-if="
                                answers[index].respuesta.subpregunta[subSIndex]
                                  .error
                              "
                              class="text-red-500 text-xs italic pb-3"
                            >
                              Ingrese la respuesta.
                            </p>
                            <!--                             <div class="w-full px-3 mb-3">
                              <label
                                class="w-full flex items-center text-gray-900"
                              >
                                <input
                                  class="mr-2 leading-tight"
                                  type="checkbox"
                                  v-model="
                                    answers[index].respuesta.subpregunta[
                                      subSIndex
                                    ].sensible
                                  "
                                />
                                <span class="text-sm">
                                  Contiene información sensible
                                </span>
                              </label>
                            </div> -->
                          </template>
                          <!-- /Subpregunta tipo selección->abierta -->

                          <!-- Subpregunta tipo selección->selección -->
                          <template v-if="subpregunta.tipo === 'SELECCION'">
                            <div class="relative">
                              <select
                                v-model="
                                  answers[index].respuesta.subpregunta[
                                    subSIndex
                                  ].respuesta.selected_answer
                                "
                                :name="'subquestion' + subSIndex"
                                class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 mb-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                              >
                                <option disabled selected>
                                  Seleccione una
                                </option>
                                <template
                                  v-for="(
                                    option, subOIndex
                                  ) in subpregunta.opciones"
                                >
                                  <option
                                    :key="'subO' + subOIndex"
                                    :value="option"
                                  >
                                    {{ option }}
                                  </option>
                                </template>
                              </select>
                              <div
                                class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                              >
                                <svg
                                  class="fill-current h-4 w-4"
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 20 20"
                                >
                                  <path
                                    d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                                  />
                                </svg>
                              </div>
                            </div>
                            <p
                              v-if="
                                answers[index].respuesta.subpregunta[subSIndex]
                                  .error
                              "
                              class="text-red-500 text-xs italic pb-3"
                            >
                              Seleccione la respuesta.
                            </p>
                          </template>
                          <!-- /Subpregunta tipo selección->selección -->

                          <!-- Subpregunta tipo selección->campos -->
                          <template v-if="subpregunta.tipo === 'CAMPOS'">
                            <template
                              v-for="(
                                campo, subFieldIndex
                              ) in subpregunta.campos"
                            >
                              <template v-if="campo.tipo === 'texto'">
                                <div :key="'subf' + subFieldIndex">
                                  <label
                                    class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                                    :for="'subquestionField' + subFieldIndex"
                                    >{{ campo.texto }}</label
                                  >
                                  <input
                                    class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                    :id="'subquestionField' + subFieldIndex"
                                    type="text"
                                    :name="'subquestionField' + subFieldIndex"
                                    v-model="
                                      answers[index].respuesta.subpregunta[
                                        subSIndex
                                      ].respuesta[campo.texto]
                                    "
                                  />
                                </div>
                              </template>
                            </template>
                            <p
                              v-if="
                                answers[index].respuesta.subpregunta[subSIndex]
                                  .error
                              "
                              class="text-red-500 text-xs italic pb-3"
                            >
                              Ingrese la respuesta.
                            </p>
                            <!--                             <div class="w-full px-3 mb-3">
                              <label
                                class="w-full flex items-center text-gray-900"
                              >
                                <input
                                  class="mr-2 leading-tight"
                                  type="checkbox"
                                  v-model="
                                    answers[index].respuesta.subpregunta[
                                      subSIndex
                                    ].sensible
                                  "
                                />
                                <span class="text-sm">
                                  Contiene información sensible
                                </span>
                              </label>
                            </div> -->
                          </template>
                          <!-- /Subpregunta tipo selección->campos -->
                        </div>
                      </template>
                      <!-- /subpreguntas de la pregunta de selección -->
                    </div>
                    <!-- /pregunta tipo SELECCION -->

                    <!-- pregunta tipo CAMPOS -->
                    <div v-if="question.tipo === 'CAMPOS'">
                      <div class="w-full px-3 mb-6 md:mb-0">
                        <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                          :for="'question' + index"
                          >{{ question.numero_pregunta }}.-
                          {{ question.texto }}</label
                        >
                        <p
                          v-if="question.nota_para_registrante"
                          class="text-purple-700 text-xs italic font-bold mb-2 text-left"
                        >
                          {{ question.nota_para_registrante }}
                        </p>

                        <template
                          v-for="(campo, fieldIndex) in question.campos"
                        >
                            <div :key="'f' + fieldIndex" class="mb-3">
                              <label
                                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                                :for="'questionField' + fieldIndex"
                                >{{ campo.texto }}</label
                              >
                              <input
                                class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                :id="'questionField' + fieldIndex"
                                :type="campo.tipo === 'numero' ? 'number' : (campo.tipo === 'fecha' ? 'date' : (campo.tipo === 'hora' ? 'time' : 'text'))"
                                :min="campo.tipo === 'numero' ? campo.rango_min : null"
                                :max="campo.tipo === 'numero' ? campo.rango_max : null"
                                :name="'questionField' + fieldIndex"
                                v-model="answers[index].respuesta[campo.texto]"
                              />
                            </div>
                        </template>
                        <p
                          v-if="answers[index].error"
                          class="text-red-500 text-xs italic pb-3"
                        >
                          Ingrese la respuesta.
                        </p>
                        <!--                         <div class="w-full px-3 mb-3">
                          <label class="w-full flex items-center text-gray-900">
                            <input
                              class="mr-2 leading-tight"
                              type="checkbox"
                              v-model="answers[index].sensible"
                            />
                            <span class="text-sm">
                              Contiene información sensible
                            </span>
                          </label>
                        </div> -->
                      </div>
                    </div>
                    <!-- /pregunta tipo CAMPOS -->

                    <!-- pregunta tipo MINI_FORMULARIO -->
                    <div v-if="question.tipo === 'MINI_FORMULARIO'">
                      <div class="w-full px-3 mb-6 md:mb-0">
                        <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                          :for="'question' + index"
                          >{{ question.numero_pregunta }}.-
                          {{ question.texto }}</label
                        >
                        <p
                          v-if="question.nota_para_registrante"
                          class="text-purple-700 text-xs italic font-bold mb-2 text-left"
                        >
                          {{ question.nota_para_registrante }}
                        </p>
                        <template>
                            <div v-for="(campo, fieldIndex) in question.campos" :key="'mf' + fieldIndex" class="mb-3">
                              <label
                                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                                :for="'mfField' + fieldIndex"
                                >{{ campo.texto }}</label
                              >
                              <template v-if="['texto', 'numero', 'fecha', 'hora'].includes(campo.tipo)">
                                <input
                                  class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                  :id="'mfField' + fieldIndex"
                                  :type="campo.tipo === 'numero' ? 'number' : (campo.tipo === 'fecha' ? 'date' : (campo.tipo === 'hora' ? 'time' : 'text'))"
                                  :min="campo.tipo === 'numero' ? campo.rango_min : null"
                                  :max="campo.tipo === 'numero' ? campo.rango_max : null"
                                  :name="'mfField' + fieldIndex"
                                  v-model="answers[index].respuesta[campo.texto]"
                                />
                              </template>
                              <template v-else-if="campo.tipo === 'radio'">
                                <div class="flex flex-col gap-2 mb-3 mt-1">
                                  <label v-for="(opt, oi) in campo.opciones" :key="'mfr' + oi" class="flex items-center gap-2 cursor-pointer text-sm text-gray-700">
                                    <input type="radio"
                                      :name="'mfField' + index + '_' + fieldIndex"
                                      :value="opt"
                                      v-model="answers[index].respuesta[campo.texto]"
                                      class="accent-teal-500"
                                    />
                                    {{ opt }}
                                  </label>
                                </div>
                              </template>
                              <template v-else-if="campo.tipo === 'checkbox'">
                                <div class="flex flex-col gap-2 mb-3 mt-1">
                                  <label v-for="(opt, oi) in campo.opciones" :key="'mfc' + oi" class="flex items-center gap-2 cursor-pointer text-sm text-gray-700">
                                    <input type="checkbox"
                                      :name="'mfField' + index + '_' + fieldIndex + '_' + oi"
                                      :value="opt"
                                      v-model="answers[index].respuesta[campo.texto]"
                                      class="accent-teal-500"
                                    />
                                    {{ opt }}
                                  </label>
                                </div>
                              </template>
                              <template v-else-if="campo.tipo === 'select'">
                                <div class="relative mt-1 mb-3">
                                  <select
                                    v-model="answers[index].respuesta[campo.texto]"
                                    :name="'mfField' + index + '_' + fieldIndex"
                                    class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                  >
                                    <option disabled selected value="">Seleccione una</option>
                                    <option v-for="(option, oIndex) in campo.opciones" :key="'mfs' + oIndex" :value="option">
                                      {{ option }}
                                    </option>
                                  </select>
                                  <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                                    <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                      <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
                                    </svg>
                                  </div>
                                </div>
                              </template>
                            </div>
                        </template>
                        <p
                          v-if="answers[index].error"
                          class="text-red-500 text-xs italic pb-3"
                        >
                          Ingrese las respuestas obligatorias.
                        </p>
                      </div>
                    </div>
                    <!-- /pregunta tipo MINI_FORMULARIO -->

                    <!-- pregunta tipo GRUPO_REPETIBLE -->
                    <div v-if="question.tipo === 'GRUPO_REPETIBLE'">
                      <div class="w-full px-3 mb-6 md:mb-0">
                        <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                          :for="'question' + index"
                          >{{ question.numero_pregunta }}.-
                          {{ question.texto }}</label
                        >
                        <p
                          v-if="question.nota_para_registrante"
                          class="text-purple-700 text-xs italic font-bold mb-2 text-left"
                        >
                          {{ question.nota_para_registrante }}
                        </p>

                        <div v-for="(group, gIndex) in answers[index].respuesta" :key="'group_' + gIndex" class="mb-4 p-4 border border-gray-300 rounded relative bg-gray-50">
                          <button v-if="answers[index].respuesta.length > 1" @click="answers[index].respuesta.splice(gIndex, 1)" type="button" class="absolute top-2 right-2 text-red-500 hover:text-red-700">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" /></svg>
                          </button>
                          <div class="font-bold text-gray-600 mb-2 text-sm">Registro {{ gIndex + 1 }}</div>
                          
                          <template v-for="(campo, fieldIndex) in question.campos">
                            <div :key="'rgf_' + gIndex + '_' + fieldIndex" class="mb-3">
                              <label
                                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-1 text-left"
                                >{{ campo.texto }}</label
                              >
                              <template v-if="['texto', 'numero', 'fecha', 'hora'].includes(campo.tipo)">
                                <input
                                  class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 leading-tight focus:outline-none focus:bg-white"
                                  :type="campo.tipo === 'numero' ? 'number' : (campo.tipo === 'fecha' ? 'date' : (campo.tipo === 'hora' ? 'time' : 'text'))"
                                  :min="campo.tipo === 'numero' ? campo.rango_min : null"
                                  :max="campo.tipo === 'numero' ? campo.rango_max : null"
                                  v-model="answers[index].respuesta[gIndex][campo.texto]"
                                />
                              </template>
                              <template v-else-if="campo.tipo === 'radio'">
                                <div class="flex flex-col gap-2 mb-2 mt-1">
                                  <label v-for="(opt, oi) in campo.opciones" :key="'rgr_' + gIndex + '_' + oi" class="flex items-center gap-2 cursor-pointer text-sm text-gray-700">
                                    <input type="radio"
                                      :name="'rgField_' + index + '_' + gIndex + '_' + fieldIndex"
                                      :value="opt"
                                      v-model="answers[index].respuesta[gIndex][campo.texto]"
                                      class="accent-teal-500"
                                    />
                                    {{ opt }}
                                  </label>
                                </div>
                              </template>
                              <template v-else-if="campo.tipo === 'checkbox'">
                                <div class="flex flex-col gap-2 mb-2 mt-1">
                                  <label v-for="(opt, oi) in campo.opciones" :key="'rgc_' + gIndex + '_' + oi" class="flex items-center gap-2 cursor-pointer text-sm text-gray-700">
                                    <input type="checkbox"
                                      :name="'rgField_' + index + '_' + gIndex + '_' + fieldIndex + '_' + oi"
                                      :value="opt"
                                      v-model="answers[index].respuesta[gIndex][campo.texto]"
                                      class="accent-teal-500"
                                    />
                                    {{ opt }}
                                  </label>
                                </div>
                              </template>
                              <template v-else-if="campo.tipo === 'select'">
                                <div class="relative mt-1 mb-2">
                                  <select
                                    v-model="answers[index].respuesta[gIndex][campo.texto]"
                                    :name="'rgField_' + index + '_' + gIndex + '_' + fieldIndex"
                                    class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                  >
                                    <option disabled selected value="">Seleccione una</option>
                                    <option v-for="(option, oIndex) in campo.opciones" :key="'rgs_' + oIndex" :value="option">
                                      {{ option }}
                                    </option>
                                  </select>
                                  <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                                    <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                      <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
                                    </svg>
                                  </div>
                                </div>
                              </template>
                            </div>
                          </template>
                        </div>
                        
                        <button type="button" @click="addRepeatableGroup(index)" class="flex items-center text-sm text-teal-600 hover:text-teal-800 font-bold mb-3">
                          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-1" viewBox="0 0 20 20" fill="currentColor">
                            <path fill-rule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clip-rule="evenodd" />
                          </svg>
                          Agregar otro registro
                        </button>

                        <p
                          v-if="answers[index].error"
                          class="text-red-500 text-xs italic pb-3"
                        >
                          Complete los campos obligatorios.
                        </p>
                      </div>
                    </div>
                    <!-- /pregunta tipo GRUPO_REPETIBLE -->


                    <!-- pregunta tipo MATRIZ -->
                    <div v-if="question.tipo === 'MATRIZ'">
                      <div class="w-full px-3 mb-6 md:mb-0">
                        <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                          :for="'question' + index"
                          >{{ question.numero_pregunta }}.- {{ question.texto }}</label
                        >
                        <p
                          v-if="question.nota_para_registrante"
                          class="text-purple-700 text-xs italic font-bold mb-2 text-left"
                        >
                          {{ question.nota_para_registrante }}
                        </p>
                        <div class="overflow-x-auto mb-3">
                          <table class="w-full text-left border-collapse">
                            <thead>
                              <tr>
                                <th class="border-b-2 p-2"></th>
                                <th
                                  v-for="(col, colIdx) in question.columnas"
                                  :key="'col' + colIdx"
                                  class="border-b-2 p-2 text-sm text-gray-700 font-bold text-center"
                                >
                                  {{ col }}
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(fila, filaIdx) in question.filas"
                                :key="'fila' + filaIdx"
                              >
                                <td class="border-b p-2 text-sm text-gray-700 font-bold">
                                  {{ fila }}
                                </td>
                                <td
                                  v-for="(col, colIdx) in question.columnas"
                                  :key="'td' + filaIdx + '_' + colIdx"
                                  class="border-b p-2 text-center"
                                >
                                  <input
                                    type="radio"
                                    :name="'matrix_' + index + '_' + filaIdx"
                                    :value="col"
                                    v-model="answers[index].respuesta[fila]"
                                    class="leading-tight"
                                  />
                                </td>
                              </tr>
                              <tr v-if="question.otro">
                                <td class="border-b p-2 text-sm text-gray-700 font-bold">
                                  <input
                                    v-if="!question.tipo_otro || question.tipo_otro === 'texto'"
                                    type="text"
                                    placeholder="Otro (opcional)..."
                                    class="appearance-none bg-gray-200 text-gray-700 border rounded py-1 px-2 text-xs leading-tight focus:outline-none focus:bg-white w-full max-w-xs"
                                    v-model="answers[index].respuesta_otro_fila"
                                  />
                                  <input
                                    v-else-if="question.tipo_otro === 'numero'"
                                    type="number"
                                    placeholder="Otro (opcional)..."
                                    class="appearance-none bg-gray-200 text-gray-700 border rounded py-1 px-2 text-xs leading-tight focus:outline-none focus:bg-white w-full max-w-xs"
                                    v-model.number="answers[index].respuesta_otro_fila"
                                  />
                                  <input
                                    v-else-if="question.tipo_otro === 'fecha'"
                                    type="date"
                                    placeholder="Otro (opcional)..."
                                    class="appearance-none bg-gray-200 text-gray-700 border rounded py-1 px-2 text-xs leading-tight focus:outline-none focus:bg-white w-full max-w-xs"
                                    v-model="answers[index].respuesta_otro_fila"
                                  />
                                  <input
                                    v-else-if="question.tipo_otro === 'hora'"
                                    type="time"
                                    placeholder="Otro (opcional)..."
                                    class="appearance-none bg-gray-200 text-gray-700 border rounded py-1 px-2 text-xs leading-tight focus:outline-none focus:bg-white w-full max-w-xs"
                                    v-model="answers[index].respuesta_otro_fila"
                                  />
                                </td>
                                <td
                                  v-for="(col, colIdx) in question.columnas"
                                  :key="'td_otro_' + colIdx"
                                  class="border-b p-2 text-center"
                                >
                                  <input
                                    type="radio"
                                    :name="'matrix_' + index + '_otro'"
                                    :value="col"
                                    v-model="answers[index].respuesta_otro_valor"
                                    class="leading-tight"
                                  />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <p
                          v-if="answers[index].error"
                          class="text-red-500 text-xs italic pb-3"
                        >
                          Conteste todas las filas de la matriz.
                        </p>
                      </div>
                    </div>
                    <!-- /pregunta tipo MATRIZ -->

                    <!-- pregunta tipo FECHA -->
                    <div v-if="question.tipo === 'FECHA'">
                      <div class="w-full px-3 mb-6 md:mb-0">
                        <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                          :for="'question' + index"
                          >{{ question.numero_pregunta }}.-
                          {{ question.texto }}</label
                        >
                        <p
                          v-if="question.nota_para_registrante"
                          class="text-purple-700 text-xs italic font-bold mb-2 text-left"
                        >
                          {{ question.nota_para_registrante }}
                        </p>
                        <div class="w-1/2 lg:w-2/3 px-3 mb-6 md:mb-0">
                          <input
                            class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                            :id="'question' + index"
                            type="date"
                            :name="'question' + index"
                            v-model="answers[index].respuesta"
                          />
                        </div>
                        <p
                          v-if="answers[index].error"
                          class="text-red-500 text-xs italic pb-3"
                        >
                          Ingrese la respuesta.
                        </p>
                      </div>
                    </div>
                    <!-- /pregunta tipo FECHA -->
                  </div>
                </div>
              </div>
              <!-- /Formulario de ficha -->

              <div class="flex w-full justify-end">
                <btn-action
                  class="px-4 py-2 text-center rounded-lg text-gray-100 tracking-wide"
                  @click="saveLevantamiento()"
                  :colorT="colorT"
                >
                  Guardar
                </btn-action>
                <button
                  class="ml-2 bg-red-700 px-4 py-2 text-center rounded-lg text-white tracking-wide"
                  @click="close()"
                >
                  Cerrar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <alert-dialog :showing="showingSuccess">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">
          Levantamiento guardado correctamente
        </div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-green-400"
            viewBox="0 0 24 24"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="closeModal()"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>

    <alert-dialog :showing="showingError">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">Ha ocurrido un error.</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-cdmx-red"
            viewBox="0 0 24 24"
          >
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingError = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>
  </div>
</template>
<script>
import AlertDialog from "./AlertDialog";
import EventBus from "../event-bus";

import { styled } from "@egoist/vue-emotion";

const DivTitle = styled("div")`
  color: ${props => props.colorP};
`;

const BtnAction = styled("button")`
  background-color: ${props => props.colorT};
`;

export default {
  name: "user-raising-update-questions-modal",
  data() {
    return {
      raising: null,
      categories: [],
      questions: [],
      answers: [],
      errors: {
        codeError: "Ha ocurrido un error"
      },
      showingSuccess: false,
      showingError: false,
      config: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken")
        }
      }
    };
  },
  props: {
    showing: {
      required: true,
      type: Boolean
    },
    colorP: {
      required: true
    },
    colorS: {
      required: true
    },
    colorT: {
      required: true
    }
  },
  mounted() {
    EventBus.$on("updateQuestionsModal", this.setData);
  },
  components: {
    AlertDialog,
    DivTitle,
    BtnAction
  },
  methods: {
    addRepeatableGroup(index) {
      let emptyGroup = {};
      if (this.questions[index].campos) {
        this.questions[index].campos.forEach(field => {
          if (field.tipo === 'checkbox') {
            emptyGroup[field.texto] = [];
          } else {
            emptyGroup[field.texto] = "";
          }
        });
      }
      this.answers[index].respuesta.push(emptyGroup);
    },
    reset: function () {
      this.raising = null;
      this.questions = [];
      this.answers = [];
      this.errors = {
        codeError: "Ha ocurrido un error"
      };
      //this.showingSuccess = false;
      this.showingError = false;
    },
    closeModal() {
      this.showingSuccess = false;
    },
    close() {
      this.reset();
      this.$emit("close");
    },
    setData(raising) {
      this.raising = Object.assign({}, raising);
      if (this.raising.id_project) {
        this.fetchProjectQuestions();
      } else {
        this.fetchQuestions();
      }
    },
    fetchQuestions() {
      this.$root.$emit("showLoading");
      this.axios
        .post(
          "apidev/levantamientos/getFichaPreguntas",
          {
            id_cat_principal: this.raising.id_cat_principal,
            existente: true
          },
          this.config
        )
        .then(response => {
          this.questions = response.data.questions;

          this.formatQuestions();

          this.$root.$emit("hideLoading");
        })
        .catch(error => {
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
          this.$root.$emit("hideLoading");
        });
    },
    fetchProjectQuestions() {
      this.$root.$emit("showLoading");
      this.axios
        .post(
          "apidev/projects/getFichaRespuestasJson",
          {
            id_project: this.raising.id_project
          },
          this.config
        )
        .then(response => {
          this.questions = response.data.answers;

          this.formatQuestions();

          this.$root.$emit("hideLoading");
        })
        .catch(error => {
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
          this.$root.$emit("hideLoading");
        });
    },
    formatQuestions() {
      this.answers = [];
      // removed console log
      // removed console log
      this.questions.forEach(question => {
        let answer;
        let found_answer = this.raising.curret_questions.find(
          answer => answer.id_pregunta === question.id_pregunta
        );

        switch (question.tipo) {
          case "ABIERTA":
            //listo
            answer = found_answer ? found_answer.respuesta : "";
            break;
          case "FOTO":
            answer = found_answer ? found_answer.respuesta : "";
            break;
          case "MULTISELECCION":
            // removed console log
            answer = {
              opciones: {}
            };

            if (found_answer) {
              answer["opciones"] = found_answer.respuesta.opciones;
              answer["otro"] = found_answer.respuesta["otro"];
              /* answer["otro"] = found_answer.respuesta.opciones["otro"]; */
            } else {
              question.opciones.forEach(option => {
                answer.opciones[option] = false;
              });
              if (question.otro) {
                answer["otro"] = "";
              }
            }
            // removed console log

            /*             if (question["subpregunta"] && question["subpregunta"].length>0) {
              answer["subpregunta"] = {};
              answer["subpregunta"]["id_pregunta"] =
                question["subpregunta"][0].id_pregunta;
              answer["subpregunta"]["texto"] = question["subpregunta"][0].texto;
              answer["subpregunta"]["tipo"] = question["subpregunta"][0].tipo;
              answer["subpregunta"]["respuesta"] = {};
              if (question["subpregunta"][0].tipo == "CAMPOS") {
                answer["subpregunta"]["sensible"] = false;
                question["subpregunta"][0].campos.forEach((field) => {
                  answer["subpregunta"]["respuesta"][field.texto] = "";
                });
              }
            } */
            if (question["subpregunta"] && question["subpregunta"].length > 0) {
              if (question["subpregunta"].length > 0) {
                answer["subpregunta"] = [];
                question["subpregunta"].forEach(question => {
                  let subAnswer = {
                    respuesta: null
                  };
                  subAnswer.id_pregunta = question.id_pregunta;
                  subAnswer.texto = question.texto;
                  subAnswer.tipo = question.tipo;

                  let found_subAnswer;
                  if (found_answer) {
                    found_subAnswer = found_answer.respuesta.subpregunta.find(
                      answer => answer.id_pregunta === question.id_pregunta
                    );
                  }

                  if (found_subAnswer) {
                    subAnswer.respuesta = found_subAnswer.respuesta;
                  } else {
                    if (question.tipo === "ABIERTA") {
                      subAnswer.respuesta = "";
                    }

                    if (question.tipo === "SELECCION") {
                      subAnswer.respuesta = {
                        selected_answer: ""
                      };
                    }

                    if (question.tipo === "CAMPOS") {
                      subAnswer.respuesta = {};

                      question.campos.forEach(campo => {
                        subAnswer.respuesta[campo.texto] = "";
                      });
                    }
                  }

                  subAnswer.error = false;

                  answer["subpregunta"].push(subAnswer);
                });
              }
            }
            break;
          case "MULTISELECCION_CATEGORIAS":
            answer = {};
            if (question["otro"] == true) {
              answer["otro"] = "";
            }
            answer["categorias"] = {};
            question.categorias.forEach(categoria => {
              answer["categorias"][categoria.categoria_nombre] = {};
              categoria.opciones.forEach(opcion => {
                answer["categorias"][categoria.categoria_nombre][
                  opcion
                ] = false;
              });
            });
            break;
          case "SELECCION_CONDICIONAL":
            //LISTO
            answer = {};
            answer["selected_answer"] = found_answer
              ? found_answer.respuesta.selected_answer
              : "";
            answer["conditional_answer"] = {};

            Object.entries(question.pregunta_condicion).forEach(
              ([key, value]) => {
                answer["conditional_answer"][key] = {};
                answer["conditional_answer"][key]["id"] = value["id"];
                answer["conditional_answer"][key]["tipo"] = value["tipo"];
                answer["conditional_answer"][key]["texto"] = value["texto"];

                if (found_answer) {
                  if (
                    found_answer.respuesta.conditional_answer.hasOwnProperty(
                      key
                    )
                  ) {
                    answer["conditional_answer"][key]["respuesta"] =
                      found_answer.respuesta.conditional_answer[key][
                        "respuesta"
                      ];
                    if (
                      value["tipo"] == "ABIERTA" ||
                      value["tipo"] == "CAMPOS"
                    ) {
                      answer["conditional_answer"][key]["sensible"] =
                        found_answer.respuesta.conditional_answer[key][
                          "sensible"
                        ];
                    }

                    if (value["tipo"] == "MULTISELECCION") {
                      if (
                        found_answer.respuesta.conditional_answer[key][
                          "respuesta"
                        ]["otro"] != ""
                      ) {
                        answer["conditional_answer"][key]["respuesta"][
                          "checked_otro"
                        ] = true;
                      }
                    }
                    if (
                      found_answer.respuesta.conditional_answer[key][
                        "subpregunta"
                      ]
                    ) {
                      answer["conditional_answer"][key]["subpregunta"] =
                        found_answer.respuesta.conditional_answer[key][
                          "subpregunta"
                        ];
                    } else {
                      if (question.pregunta_condicion[key].subpregunta) {
                        let subAnswers = [];
                        question.pregunta_condicion[key].subpregunta.forEach(
                          subpregunta => {
                            let subAnswer = {
                              id_pregunta: subpregunta.id_pregunta,
                              texto: subpregunta.texto,
                              tipo: subpregunta.tipo,
                              respuesta: ""
                            };
                            subAnswers.push(subAnswer);
                          }
                        );

                        answer["conditional_answer"][key].subpregunta =
                          subAnswers;
                      }
                    }
                  } else {
                    if (value["tipo"] == "ABIERTA") {
                      answer["conditional_answer"][key]["respuesta"] = "";
                    }

                    if (value["tipo"] == "MULTISELECCION") {
                      answer["conditional_answer"][key]["respuesta"] = {};

                      answer["conditional_answer"][key]["respuesta"][
                        "opciones"
                      ] = {};
                      value["opciones"].forEach(opcion => {
                        answer["conditional_answer"][key]["respuesta"][
                          "opciones"
                        ][opcion] = false;
                      });

                      if (value["otro"] == true) {
                        answer["conditional_answer"][key]["respuesta"]["otro"] =
                          "";
                      }
                    }
                    if (value["tipo"] == "MULTISELECCION_CATEGORIAS") {
                      answer["conditional_answer"][key]["respuesta"] = {};
                      answer["conditional_answer"][key]["respuesta"][
                        "categorias"
                      ] = {};
                      value["categorias"].forEach(categoria => {
                        answer["conditional_answer"][key]["respuesta"][
                          "categorias"
                        ][categoria.categoria_nombre] = {};
                        categoria.opciones.forEach(opcion => {
                          answer["conditional_answer"][key]["respuesta"][
                            "categorias"
                          ][categoria.categoria_nombre][opcion] = false;
                        });
                      });
                      if (value["otro"] == true) {
                        answer["conditional_answer"][key]["respuesta"]["otro"] =
                          "";
                      }
                    }

                    if (value["tipo"] == "SELECCION") {
                      answer["conditional_answer"][key]["respuesta"] = "";
                    }

                    if (value["tipo"] === "CAMPOS") {
                      answer["conditional_answer"][key]["respuesta"] = {};
                      question.pregunta_condicion[key].campos.forEach(field => {
                        answer["conditional_answer"][key]["respuesta"][
                          field.texto
                        ] = "";
                      });
                    }

                    if (question.pregunta_condicion[key].subpregunta) {
                      let subAnswers = [];
                      question.pregunta_condicion[key].subpregunta.forEach(
                        subpregunta => {
                          let subAnswer = {
                            id_pregunta: subpregunta.id_pregunta,
                            texto: subpregunta.texto,
                            tipo: subpregunta.tipo,
                            respuesta: ""
                          };
                          subAnswers.push(subAnswer);
                        }
                      );

                      answer["conditional_answer"][key].subpregunta =
                        subAnswers;
                    }
                  }
                }

                answer["conditional_answer"][key]["error"] = false;
              }
            );
            break;
          case "SELECCION":
            //En proceso
            answer = {};

            if (question.otro) {
              answer["otro"] = found_answer ? found_answer.respuesta.otro : "";
            }

            answer["selected_answer"] = found_answer
              ? found_answer.respuesta.selected_answer
              : "";

            if (question["subpregunta"] && question["subpregunta"].length > 0) {
              if (question["subpregunta"].length > 0) {
                answer["subpregunta"] = [];
                question["subpregunta"].forEach(question => {
                  let subAnswer = {
                    respuesta: null
                  };
                  subAnswer.id_pregunta = question.id_pregunta;
                  subAnswer.texto = question.texto;
                  subAnswer.tipo = question.tipo;

                  let found_subAnswer;
                  if (found_answer) {
                    found_subAnswer = found_answer.respuesta.subpregunta.find(
                      answer => answer.id_pregunta === question.id_pregunta
                    );
                  }

                  if (found_subAnswer) {
                    subAnswer.respuesta = found_subAnswer.respuesta;
                  } else {
                    if (question.tipo === "ABIERTA") {
                      subAnswer.respuesta = "";
                    }

                    if (question.tipo === "SELECCION") {
                      subAnswer.respuesta = {
                        selected_answer: ""
                      };
                    }

                    if (question.tipo === "CAMPOS") {
                      subAnswer.respuesta = {};

                      question.campos.forEach(campo => {
                        subAnswer.respuesta[campo.texto] = "";
                      });
                    }
                  }

                  subAnswer.error = false;

                  answer["subpregunta"].push(subAnswer);
                });
              }
            }
            break;
          case "CAMPOS":
            answer = found_answer ? found_answer.respuesta : {};
            break;
          case "MINI_FORMULARIO":
            if (found_answer && found_answer.respuesta) {
              answer = found_answer.respuesta;
            } else {
              answer = {};
              if (question.campos) {
                question.campos.forEach(field => {
                  if (field.tipo === 'checkbox') {
                    answer[field.texto] = [];
                  } else {
                    answer[field.texto] = "";
                  }
                });
              }
            }
            break;
          case "GRUPO_REPETIBLE":
            if (found_answer && found_answer.respuesta && Array.isArray(found_answer.respuesta) && found_answer.respuesta.length > 0) {
              answer = found_answer.respuesta;
            } else {
              answer = [];
              let emptyGroup = {};
              if (question.campos) {
                question.campos.forEach(field => {
                  if (field.tipo === 'checkbox') {
                    emptyGroup[field.texto] = [];
                  } else {
                    emptyGroup[field.texto] = "";
                  }
                });
              }
              answer.push(emptyGroup);
            }
            break;
          case "OPCION_SEGUIMIENTO":
            if (found_answer && found_answer.respuesta) {
              answer = found_answer.respuesta;
            } else {
              answer = [];
              if (question.conceptos) {
                question.conceptos.forEach(concepto => {
                  answer.push({
                    concepto: concepto,
                    selected_answer: "",
                    sub_respuesta: question.sub_tipo === 'checkbox' ? [] : ""
                  });
                });
              }
            }
            break;
          case "MATRIZ":
            answer = (found_answer && found_answer.respuesta) ? found_answer.respuesta : {};
            if (question.filas) {
              question.filas.forEach(fila => {
                if (answer[fila] === undefined) {
                  answer[fila] = "";
                }
              });
            }
            break;
          case "FECHA":
            answer = found_answer ? found_answer.respuesta : "";
            break;
          default:
            break;
        }

        let respuestaOtroFila = "";
        let respuestaOtroValor = "";
        if (question.tipo === "MATRIZ" && found_answer && found_answer.respuesta) {
          if (found_answer.respuesta.otro_texto) {
            respuestaOtroFila = found_answer.respuesta.otro_texto;
            respuestaOtroValor = found_answer.respuesta.otro_respuesta || "";
          }
        }

        this.answers.push({
          id_pregunta: question.id_pregunta,
          texto: question.texto,
          tipo: question.tipo,
          respuesta: answer,
          respuesta_otro_fila: respuestaOtroFila,
          respuesta_otro_valor: respuestaOtroValor,
          obligatoria: question.obligatoria,
          sensible: found_answer ? found_answer.sensible : false,
          error: false
        });
      });
    },
    saveLevantamiento() {
      //// removed console log

      if (this.answers.length > 0) {
        let validQuestions = false;
        if (this.raising.editQuestion == true) {
          validQuestions = true;
        } else {
          validQuestions = this.validateAnswers();
        }

        if (validQuestions) {
          this.$root.$emit("showLoading");
          let request = {};
          let userAnswers = {};

          this.answers.forEach(answer => {
            delete answer.error;
            if (answer.tipo === "SELECCION_CONDICIONAL") {
              let user_answer = {};
              for (let key in answer.respuesta.conditional_answer) {
                if (key === answer.respuesta.selected_answer) {
                  delete answer.respuesta.conditional_answer[key].error;
                  user_answer[key] = answer.respuesta.conditional_answer[key];
                }
              }

              answer.respuesta.conditional_answer = user_answer;
            }

            if (answer.tipo === "SELECCION") {
              if (answer.respuesta.selected_answer !== "Otro") {
                answer.respuesta.otro = "";
              }

              if (answer.respuesta.subpregunta) {
                if (answer.respuesta.subpregunta.length > 0) {
                  answer.respuesta.subpregunta.forEach(subpregunta => {
                    delete subpregunta.error;
                  });
                }
              }
            }

            if (answer.tipo === "MATRIZ") {
              if (answer.respuesta_otro_fila && answer.respuesta_otro_fila.trim() !== "" && answer.respuesta_otro_valor) {
                answer.respuesta.otro_texto = answer.respuesta_otro_fila.trim();
                answer.respuesta.otro_respuesta = answer.respuesta_otro_valor;
              } else {
                delete answer.respuesta.otro_texto;
                delete answer.respuesta.otro_respuesta;
              }
            }
          });

          this.questions.forEach((question, index) => {
            userAnswers[question.id_pregunta] = this.answers[index];
          });

          request = {
            id: this.raising.id,
            id_cat_principal: this.raising.id_cat_principal,
            id_usuario: localStorage.getItem("user_id"),
            registro: null,
            respuestas: userAnswers
          };

          this.axios
            .put(
              "../apidev/levantamientos/updatePreguntas",
              request,
              this.config
            )
            .then(() => {
              this.$root.$emit("hideLoading");
              this.showingSuccess = true;
              this.$emit("updateQuestions");
              this.close();
            })
            .catch(error => this.catchError(error));
        }
      } else {
        this.close();
      }
    },
    validateAnswers() {
      let isValid = true;
      let requiredAnswers = this.answers.filter((answer, index) => {
        let isVisible = this.isQuestionVisible(index);
        
        // Si no es visible, limpiamos su respuesta para que se envíe vacía
        if (!isVisible) {
          answer.error = false;
          answer.error_rango = false;
          if (answer.tipo === "ABIERTA" || answer.tipo === "FECHA") {
            answer.respuesta = "";
          } else if (answer.tipo === "SELECCION") {
            answer.respuesta.selected_answer = "";
            answer.respuesta.otro = "";
          } else if (answer.tipo === "OPCION_SEGUIMIENTO") {
            if (Array.isArray(answer.respuesta)) {
              answer.respuesta.forEach(r => {
                r.selected_answer = "";
                r.sub_respuesta = Array.isArray(r.sub_respuesta) ? [] : "";
              });
            }
          } else if (answer.tipo === "MATRIZ" || answer.tipo === "CAMPOS" || answer.tipo === "MINI_FORMULARIO" || answer.tipo === "GRUPO_REPETIBLE") {
            for (let key in answer.respuesta) {
              if (Array.isArray(answer.respuesta[key])) {
                answer.respuesta[key] = [];
              } else if (typeof answer.respuesta[key] === 'object' && answer.respuesta[key] !== null) {
                for (let subKey in answer.respuesta[key]) {
                  answer.respuesta[key][subKey] = Array.isArray(answer.respuesta[key][subKey]) ? [] : "";
                }
              } else {
                answer.respuesta[key] = "";
              }
            }
          }
          // Ignorar validación de esta pregunta
          return false; 
        }

        return answer.obligatoria;
      });

      requiredAnswers.forEach(answer => {
        switch (answer.tipo) {
          case "ABIERTA":
            answer.error = false;
            answer.error_rango = false;

            if (answer.respuesta === "") {
              isValid = false;
              answer.error = true;
            } else if (answer.tipo_dato === "numero") {
              const numVal = Number(answer.respuesta);
              if (isNaN(numVal)) {
                isValid = false;
                answer.error_rango = true;
              } else {
                if (answer.rango_min !== null && answer.rango_min !== "" && numVal < Number(answer.rango_min)) {
                  isValid = false;
                  answer.error_rango = true;
                }
                if (answer.rango_max !== null && answer.rango_max !== "" && numVal > Number(answer.rango_max)) {
                  isValid = false;
                  answer.error_rango = true;
                }
              }
            }
            break;
          case "SELECCION":
            if (answer.respuesta.selected_answer === "") {
              isValid = false;
              answer.error = true;
            } else {
              answer.error = false;
            }

            if (answer.respuesta.subpregunta) {
              answer.respuesta.subpregunta.forEach(subpregunta => {
                if (subpregunta.tipo === "ABIERTA") {
                  subpregunta.error = false;
                  subpregunta.error_rango = false;

                  if (subpregunta.respuesta === "") {
                    isValid = false;
                    subpregunta.error = true;
                  } else if (subpregunta.tipo_dato === "numero") {
                    const numVal = Number(subpregunta.respuesta);
                    if (isNaN(numVal)) {
                      isValid = false;
                      subpregunta.error_rango = true;
                    } else {
                      if (subpregunta.rango_min !== null && subpregunta.rango_min !== "" && numVal < Number(subpregunta.rango_min)) {
                        isValid = false;
                        subpregunta.error_rango = true;
                      }
                      if (subpregunta.rango_max !== null && subpregunta.rango_max !== "" && numVal > Number(subpregunta.rango_max)) {
                        isValid = false;
                        subpregunta.error_rango = true;
                      }
                    }
                  }
                }

                if (subpregunta.tipo === "SELECCION") {
                  if (subpregunta.respuesta.selected_answer === "") {
                    isValid = false;
                    subpregunta.error = true;
                  } else {
                    subpregunta.error = false;
                  }
                }

                if (subpregunta.tipo === "CAMPOS") {
                  let haveEmpty = false;
                  for (let key in subpregunta.respuesta) {
                    if (subpregunta.respuesta[key] === "") {
                      haveEmpty = true;
                      isValid = false;
                      subpregunta.error = true;
                    }
                  }

                  if (!haveEmpty) {
                    subpregunta.error = false;
                  }
                }
              });
            }

            break;
          case "SELECCION_CONDICIONAL":
            if (answer.respuesta.selected_answer === "") {
              isValid = false;
              answer.error = true;
            } else {
              answer.error = false;
              if (
                answer.respuesta.conditional_answer[
                  answer.respuesta.selected_answer
                ]
              ) {
                if (
                  answer.respuesta.conditional_answer[
                    answer.respuesta.selected_answer
                  ].respuesta === ""
                ) {
                  isValid = false;
                  answer.respuesta.conditional_answer[
                    answer.respuesta.selected_answer
                  ].error = true;
                } else {
                  answer.respuesta.conditional_answer[
                    answer.respuesta.selected_answer
                  ].error = false;
                }
              }
            }
            break;
          case "OPCION_SEGUIMIENTO":
            if (answer.obligatoria) {
              let incomplete = false;
              if (Array.isArray(answer.respuesta)) {
                for (let i = 0; i < answer.respuesta.length; i++) {
                  let r = answer.respuesta[i];
                  if (!r.selected_answer) {
                    incomplete = true;
                    break;
                  }
                  if (r.selected_answer === answer.opcion_si) {
                    if (answer.sub_tipo === 'checkbox') {
                      if (!r.sub_respuesta || r.sub_respuesta.length === 0) {
                        incomplete = true;
                        break;
                      }
                    } else {
                      if (!r.sub_respuesta || r.sub_respuesta.toString().trim() === "") {
                        incomplete = true;
                        break;
                      }
                    }
                  }
                }
              } else {
                incomplete = true;
              }
              if (incomplete) {
                isValid = false;
                answer.error = true;
              } else {
                answer.error = false;
              }
            } else {
              answer.error = false;
            }
            break;
          case "MINI_FORMULARIO":
          case "CAMPOS": {
            let haveEmpty = false;
            for (let key in answer.respuesta) {
              if (answer.respuesta[key] === "" || (Array.isArray(answer.respuesta[key]) && answer.respuesta[key].length === 0)) {
                haveEmpty = true;
                isValid = false;
              }
            }
            if (haveEmpty) {
              answer.error = true;
            } else {
              answer.error = false;
            }
            break;
          }
          case "GRUPO_REPETIBLE": {
            let haveEmpty = false;
            if (Array.isArray(answer.respuesta)) {
              for (let i = 0; i < answer.respuesta.length; i++) {
                let group = answer.respuesta[i];
                for (let key in group) {
                  if (group[key] === "" || (Array.isArray(group[key]) && group[key].length === 0)) {
                    haveEmpty = true;
                    isValid = false;
                  }
                }
              }
            }
            answer.error = haveEmpty;
            break;
          }
          case "MATRIZ": {
            let haveEmpty = false;
            let q = this.questions[this.answers.indexOf(answer)];
            if (q && q.filas) {
              for (let fila of q.filas) {
                if (!answer.respuesta || answer.respuesta[fila] === "" || answer.respuesta[fila] === null || answer.respuesta[fila] === undefined) {
                  haveEmpty = true;
                  isValid = false;
                  answer.error = true;
                  break;
                }
              }
            }
            if (!haveEmpty) {
              answer.error = false;
            }
            break;
          }
          case "FOTO":
            if (
              !answer.respuesta ||
              (Array.isArray(answer.respuesta) && answer.respuesta.length === 0) ||
              answer.respuesta === ""
            ) {
              isValid = false;
              answer.error = true;
            } else {
              answer.error = false;
            }
            break;
          case "FECHA":
            if (answer.respuesta === "") {
              isValid = false;
              answer.error = true;
            } else {
              answer.error = false;
            }
            break;
          default:
            break;
        }
      });

      return isValid;
    },
    catchError(error) {
      // removed console log
      this.$root.$emit("hideLoading");
      if (error.response.status == 400 || error.response.status == 401) {
        if (
          error.response.data.name === "TokenExpiredError" ||
          error.response.data.name === "InvalidTokenError" ||
          error.response.data.name === "JsonWebTokenError"
        ) {
          this.$router.push({ path: "/login" });
        }
      }
    },
    isQuestionVisible(index) {
      if (index === 0) return true;
      let targetJumpIndex = -1;

      for (let i = 0; i < index; i++) {
        let q = this.questions[i];
        let a = this.answers[i];
        if (q.tipo === "SELECCION" && q.saltos && a && a.respuesta) {
          let selectedVal = a.respuesta.selected_answer;
          let saltoTarget = null;
          
          if (selectedVal !== "") {
            if (selectedVal === "Otro") {
              saltoTarget = q.saltos['otro'];
            } else {
              let optIndex = q.opciones.indexOf(selectedVal);
              if (optIndex !== -1) {
                saltoTarget = q.saltos[optIndex];
              }
            }

            if (saltoTarget) {
              let tIndex = this.questions.findIndex(x => x.numero_pregunta == saltoTarget);
              if (tIndex > i && tIndex > targetJumpIndex) {
                targetJumpIndex = tIndex;
              }
            }
          }
        }
      }

      return index >= targetJumpIndex;
    },
    onPhotoChange(event, index) {
      const files = event.target.files;
      if (!files || files.length === 0) return;
      const maxFotos = (this.questions[index] && this.questions[index].max_fotos) ? this.questions[index].max_fotos : 4;

      let currentPhotos = Array.isArray(this.answers[index].respuesta)
        ? [...this.answers[index].respuesta]
        : (this.answers[index].respuesta ? [this.answers[index].respuesta] : []);

      const availableSlots = maxFotos - currentPhotos.length;
      if (availableSlots <= 0) {
        event.target.value = "";
        return;
      }

      const filesToAdd = Array.from(files).slice(0, availableSlots);

      filesToAdd.forEach(file => {
        const reader = new FileReader();
        reader.onload = (e) => {
          if (!Array.isArray(this.answers[index].respuesta)) {
            this.$set(this.answers[index], 'respuesta', []);
          }
          this.answers[index].respuesta.push(e.target.result);
          this.answers[index].error = false;
        };
        reader.readAsDataURL(file);
      });
      event.target.value = "";
    },
    removePhoto(questionIndex, photoIndex) {
      if (Array.isArray(this.answers[questionIndex].respuesta)) {
        this.answers[questionIndex].respuesta.splice(photoIndex, 1);
      } else {
        this.$set(this.answers[questionIndex], 'respuesta', []);
      }
    }
  }
};
</script>

<style scoped>
.bg-semi-75 {
  background-color: rgba(0, 0, 0, 0.75);
}
</style>
